import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}

export function PageHero({ title, subtitle, image }) {
  return (
    <section className="relative overflow-hidden bg-navy grain-overlay" data-testid="page-hero">
      {image && (
        <img
          src={image}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 h-full w-full object-cover opacity-25"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/85 to-navy/60" />
      <div className="relative mx-auto max-w-6xl px-5 py-20 sm:px-8 sm:py-28">
        <div className="h-1 w-16 bg-gold mb-6" aria-hidden="true" />
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-cream text-balance max-w-3xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 max-w-2xl text-base md:text-lg text-cream/80">{subtitle}</p>
        )}
      </div>
    </section>
  );
}

export function SectionHeading({ kicker, title, text, align = "left" }) {
  return (
    <div className={align === "center" ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}>
      {kicker && (
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold-dark mb-3">
          {kicker}
        </p>
      )}
      <h2 className="font-heading text-3xl sm:text-4xl font-bold text-navy text-balance">{title}</h2>
      {text && <p className="mt-4 text-base text-muted-foreground leading-relaxed">{text}</p>}
    </div>
  );
}

export function EmptyState({ title, text, testId }) {
  return (
    <div
      data-testid={testId}
      className="rounded-lg border border-dashed border-border bg-white/60 px-8 py-14 text-center"
    >
      <p className="font-heading text-xl font-bold text-navy">{title}</p>
      <p className="mt-2 text-sm text-muted-foreground max-w-md mx-auto">{text}</p>
    </div>
  );
}

export function PlaceholderNote() {
  return (
    <p className="mt-6 text-xs text-muted-foreground italic">
      Note: content marked as placeholder will be replaced with actual church information soon.
    </p>
  );
}

export function formatDate(d) {
  if (!d) return "";
  try {
    return new Date(d + (d.length === 10 ? "T00:00:00" : "")).toLocaleDateString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return d;
  }
}
